class ButtonDropdown {
  constructor(element) {
    this.element = element;
    this.btn = this.element.querySelector('[data-element="button-dropdown-btn"]');
    this.list = this.element.querySelector('[data-element="button-dropdown-list"]');
  }

  init() {
    this.btn.addEventListener('click', this.onBtnClick.bind(this));
    document.addEventListener('click', this.onOutsideClick.bind(this));
  }

  onBtnClick() {
    if (this.list.classList.contains('is-open')) {
      this.closeList();
    } else {
      this.openList();
    }
  }

  onOutsideClick(event) {
    if (!this.btn.contains(event.target)) {
      this.closeList();
    }
  }

  openList() {
    this.btn.setAttribute('aria-expanded', true);
    this.list.classList.add('is-open');
  }

  closeList() {
    this.btn.setAttribute('aria-expanded', false);
    this.list.classList.remove('is-open');
  }
}

const buttonDropdown = {
  init() {
    const buttonDropdownElements = document.querySelectorAll('[data-module="button-dropdown"]');

    if (buttonDropdownElements && buttonDropdownElements.length) {
      buttonDropdownElements.forEach((element) => {
        const buttonDropdownElement = new ButtonDropdown(element);
        buttonDropdownElement.init();
      });
    }
  },
};

export default buttonDropdown;
